import { Component, Inject, ChangeDetectionStrategy, inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { FormGroup, FormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { emailValidator } from "src/app/shared/email-validator.directive";
import { NewsletterService } from "src/app/services/newsletter.service";
import { I18nService } from "src/app/services/i18n.service";
import { DialogContentNewsLetterDisable } from "../newsletter-dialog-disable/dialog-content-newsletter-disable";

export interface DialogData {
  acceptNewsLetter: boolean;
  email: any;
}

// Inscription à la newsletter (double opt-in : rien n'est actif avant le clic sur le lien reçu par e-mail)
@Component({
    selector: 'dialog-content-newsletter',
    templateUrl: 'dialog-content-newsletter.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DialogContentNewsLetter {

  form!: FormGroup;
  loading = false;
  sent = false;
  error = '';

  private i18n = inject(I18nService);

  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<DialogContentNewsLetter>,
    public dialog: MatDialog,
    private newsletterService: NewsletterService
  ) {
    this.form = this.fb.group({
      email: new UntypedFormControl('', [Validators.required,
        Validators.minLength(1),
        Validators.maxLength(250),
        emailValidator()]),
      // Consentement distinct, décoché par défaut
      partnerOffers: false,
    });
  }

  submit() {
    if (this.form.invalid || this.loading) {
      return;
    }
    this.loading = true;
    this.error = '';
    const { email, partnerOffers } = this.form.value;
    this.newsletterService.subscribe(email, !!partnerOffers, this.i18n.current).subscribe({
      next: () => {
        this.loading = false;
        this.sent = true;
      },
      error: err => {
        this.loading = false;
        this.error = err || this.i18n.t('common.errorOccurred');
      }
    });
  }

  close() {
    // Le header garde le même retour qu'avant : true = l'utilisateur a demandé l'inscription
    this.dialogRef.close(this.sent ? { acceptNewsLetter: true, email: this.form.value.email } : false);
  }

  public openDialogNewsLetterDisable(): void {
    this.dialogRef.close(false);
    this.dialog.open(DialogContentNewsLetterDisable, {
      width: '450px',
      data: { email: this.form.value.email },
    });
  }
}
